import React from 'react';
import styled from 'styled-components';
import {
    MediaController,
    MediaControlBar,
    MediaTimeRange,
    MediaTimeDisplay,
    MediaVolumeRange,
    MediaPlayButton,
    MediaSeekBackwardButton,
    MediaSeekForwardButton,
    MediaMuteButton,
    MediaFullscreenButton,
    MediaPlaybackRateButton,
} from 'media-chrome/react';
import { StyledMediaContainer } from '../constants/media.styled';
import { MEDIA_ACCESS_TYPE, PLAYBACK_RATES } from '../constants/media.constants';
import { ConditionalRendering } from '@components/common/conditional-rendering';


export const StyledDiv = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => `${theme.black}`};
    display: 'flex';
    align-items: 'center';
    justify-content: 'center';
    color: ${({ theme }) => `${theme.white}`};;
    font-size: '18px';
    font-weight: 'bold';
`;

interface IMediaPlayerProps {
    mediaUrl: string;
    disableDownload?: boolean;
    mediaAccessType?: number;
}

const MediaPlayer = ({ mediaUrl, disableDownload, mediaAccessType }: IMediaPlayerProps) => {
    
    const mediaProps = {
        src: mediaUrl,
        style: { height: '100%', width: '100%' },
        onContextMenu: (e: React.MouseEvent) => {
            if (disableDownload) e.preventDefault();
        }
    };

    const isAudio = mediaAccessType === MEDIA_ACCESS_TYPE.AUDIO;
    const isVideo = mediaAccessType === MEDIA_ACCESS_TYPE.VIDEO;
    const isHideMedia = mediaAccessType === MEDIA_ACCESS_TYPE.NONE;

    if (isHideMedia) {
        return null;
    }

    return (
        <StyledMediaContainer data-testid="media-player">
            <MediaController style={{ width: '100%', height: '100%' }}>
                <ConditionalRendering isTrue={isAudio}>
                    <>
                        <audio slot="media" {...mediaProps} data-testId="dataSyncAudio">
                            <track kind="captions" />
                        </audio>
                        <StyledDiv slot="poster" />
                    </>
                </ConditionalRendering>
                
                <ConditionalRendering isTrue={isVideo}>
                    <video slot="media" {...mediaProps} data-testId="dataSyncVideo">
                        <track kind="captions" />
                    </video>
                </ConditionalRendering>

                <MediaControlBar>
                    <MediaPlayButton />
                    <MediaSeekBackwardButton seekOffset={10} />
                    <MediaSeekForwardButton seekOffset={10} />
                    <MediaTimeRange />
                    <MediaTimeDisplay showDuration />
                    <MediaMuteButton />
                    <MediaVolumeRange />
                    <MediaPlaybackRateButton rates={PLAYBACK_RATES} />
                    <MediaFullscreenButton />
                </MediaControlBar>
            </MediaController>
        </StyledMediaContainer>
    );
};

export default MediaPlayer;